// Create an enum-like mapping for data type categories
export const DATA_TYPE_CATEGORY = {
    NDVI: "NDVI",
    SOIL_SENSOR: "Soil Sensor",
    SOIL_MOISTURE: "Soil Moisture",
    IRRIGATION_CONTROL: "Irrigation Control",
    WATER_FLOW: "Water Flow",
    IRRIGATION_PLANNING: "Irrigation Planning",
    ENVIRONMENTAL: "Environmental",
    PRESSURE_SENSOR: "Pressure Sensor",
    ADMIN_ONLY: "Admin Only",
} as const;
